import CityPageTemplate from "../city-template/CityPageTemplate";
import { sturgisConfig } from "./data";

export default function SturgisPage() {
  return <CityPageTemplate config={sturgisConfig} />;
}